import type { TReferral, TReferralCreatePayload, TReferralHistoryEntry } from "./types";
import {
  createPathParam,
  createPathParamCRUD,
  getPathParam,
  type NoPathParams,
} from "@/api/shared/crud";
import { createService } from "@/api/shared/service";
import type { DefaultPaginatedFilters } from "@/api/shared/filters";

export * from "./types";

const SLUG = "referral";

export default createService(SLUG, {
  acceptReferral: createPathParam<TReferral, { id: string }, {}>(`${SLUG}/{id}/accept/`),

  rejectReferral: createPathParam<TReferral, { id: string }, {}>(`${SLUG}/{id}/reject/`),

  ...createPathParamCRUD<TReferral, NoPathParams, DefaultPaginatedFilters, TReferralCreatePayload>(
    SLUG
  ),

  history: getPathParam<TReferralHistoryEntry[], { id: string }>(`${SLUG}/{id}/history`),
});
